import { useTranslation } from 'react-i18next';

/**
 * SourceChip — 受訪者來源 badge
 *
 *   preview      → 模擬 (cream)
 *   sip          → 單次外播 (amber)
 *   sip_campaign → Campaign (accent + campaign 名稱可顯示)
 */

const SOURCE_META = {
    preview: {
        labelKey: 'source.previewCall',
        bg: 'bg-cream-200',
        text: 'text-ink-700',
        border: 'border-cream-300',
    },
    sip: {
        labelKey: 'source.single',
        bg: 'bg-amber-100',
        text: 'text-amber-800',
        border: 'border-amber-200',
    },
    sip_campaign: {
        labelKey: 'source.campaign',
        bg: 'bg-accent-50',
        text: 'text-accent-700',
        border: 'border-accent-200',
    },
    inbound: {
        labelKey: 'source.inbound',
        bg: 'bg-emerald-50',
        text: 'text-emerald-700',
        border: 'border-emerald-200',
    },
};

export function SourceChip({ source, campaignName, compact = false }) {
    const { t } = useTranslation('survey');
    const conf = SOURCE_META[source];
    const meta = conf
        ? { label: t(conf.labelKey), bg: conf.bg, text: conf.text, border: conf.border }
        : { label: source || '—', bg: 'bg-cream-100', text: 'text-ink-500', border: 'border-cream-200' };
    return (
        <span
            className={[
                'inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full font-medium border',
                meta.bg, meta.text, meta.border,
            ].join(' ')}
            title={campaignName ? `${meta.label}：${campaignName}` : meta.label}
        >
            {meta.label}
            {!compact && campaignName && (
                <span className="font-normal opacity-80 truncate max-w-[120px]">· {campaignName}</span>
            )}
        </span>
    );
}

export function SourceChips({ sources = [], campaignName }) {
    if (!sources.length) return <span className="text-xs text-ink-300">—</span>;
    return (
        <div className="flex flex-wrap gap-1">
            {sources.map((s, i) => (
                <SourceChip key={i} source={s} campaignName={s === 'sip_campaign' ? campaignName : undefined} compact />
            ))}
        </div>
    );
}
